module.exports = __webpack_public_path__ + "media/images/emblems/Villars-Epeney-coat_of_arms-7455994a5b09a9b3d46000462afa2c63.svg";